import React, {Component} from 'react';
import {Input} from 'reactstrap';
import {toast} from 'react-toastify';
import _ from 'lodash';

import ErrorMsg from "../common/ErrorMsg";
import StaffDataService from "../../services/StaffDataService";
import LoadingModal from "../common/LoadingModal";


export default class ShowMessages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageList: [],
            isLoading: false
        };
    }

    componentDidMount = () => {
        this.getInitialState();
    };

    getInitialState = async () => {
        try {
            let result = await StaffDataService.getUnreadMessages();
            let messageList = [];
            if (200 === result.status) {
                messageList = result.data.map((data) => ({...data}));
                this.setState({messageList});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
    };

    closeMessage = async () => {
        try {
            let result = await StaffDataService.putUnreadMessages();
            if (200 === result.status) {
                this.props.closeMessage();
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error.response}/>, {autoClose: 5000});
        }
    };

    render() {
        const {isLoading, messageList} = this.state;
        let messageListOptions = [];

        messageListOptions = messageList.map((message, index) => {
            return <Input key={index} className="mb-3" type="textarea" rows="2" value={message.message} />;
        });
                
        return (
            <section className="container-fluid pt-3">
                <div className="clearfix"></div>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="card border border-info">
                            <div className="card-header bg-info text-white">
                                <h5 className="float-left mb-0">Messages</h5>
                                <button type="button" className="close text-white opacity-1" aria-label="Close" onClick={this.closeMessage}><span aria-hidden="true">×</span></button>
                            </div>
                            <div className="card-body">
                                {messageListOptions}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isLoading ? <LoadingModal modal={this.state.isLoading} /> : null}
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/ShowMessages.js